// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"286":"eee5c859","453":"1754d0e6","729":"cf6f51da"}[chunkId] + ".chunk.js";
};